import Multiselect from 'vue-multiselect'
export default {
  components: { Multiselect }
}



// WEBPACK FOOTER //
// ./src/mixins/dialog.js